export const styles = {
  container: [
    "flex",
    "flex-col",
    "justify-center",
    "items-center",
    "w-full",
    "h-screen",
  ].join(" "),
  "img-wrapper": [
    "w-full",
    "md:w-1/3",
    "flex-grow-0",
    "bg-black-me",
    "flex",
    "justify-center",
    "items-center",
    "pt-7",
  ].join(" "),
  svg: ["animate-spin", "h-10", "w-10", "text-yellow-me"].join(" "),
  "svg-circle": ["opacity-25"].join(" "),
};
